import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
    getName
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { ApexOptions } from "apexcharts";
import { prepareGraphData, barChartOptions } from "../../../components/src/utils";
// Customizable Area Start
// Customizable Area End

export const webConfigJSON = require("./config.js");

export interface Props {
    navigation: any;
    // Customizable Area Start
    checked: boolean
    // Customizable Area End
}
interface S {
    // Customizable Area Start
    totalAnnualRevenue: number;
    chartOptions: ApexOptions;
    series: ApexAxisChartSeries;
    loading: boolean;
    // Customizable Area End
}
interface SS { }

export default class PaymentActivitiesController extends BlockComponent<Props, S, SS> {
    // Customizable Area Start
    paymentActivitiesApiCallId: string = "";

    constructor(props: Props) {
        super(props);
        this.receive = this.receive.bind(this);

        this.subScribedMessages = [
            getName(MessageEnum.RestAPIResponceMessage),
        ];

        this.state = {
            totalAnnualRevenue: 0,
            chartOptions: { ...barChartOptions },
            series: [{ data: [], name: 'Revenue' }],
            loading: false,
        };

        runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    }

    async componentDidMount() {
        super.componentDidMount();
        this.fetchPaymentActivities();
    }

    async receive(from: string, message: Message) {
        if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
            const webApiRequestCallId = message.getData(
                getName(MessageEnum.RestAPIResponceDataMessage)
            );

            let webResponseJson = message.getData(
                getName(MessageEnum.RestAPIResponceSuccessMessage)
            );

            if (webResponseJson && !webResponseJson.errors) {
                if (webApiRequestCallId === this.paymentActivitiesApiCallId) {
                    const list = webResponseJson.payment_sent ?? [];
                    const graphData = prepareGraphData(list, this.props.checked);
                    
                    this.setState({
                        totalAnnualRevenue: webResponseJson.total_subscription_reveue ?? 0,
                        loading: false,
                        series: graphData.series,
                        chartOptions: graphData.options,
                    });
                }
            }
        }
    }

    navigateToEarnigs = () => {
        this.props.navigation.navigate("Earnings");
    }

    fetchPaymentActivities = () => {
        this.setState({ loading: true })
        const token = localStorage.getItem("authToken");
        const headers = {
            'Content-Type': webConfigJSON.dashboarContentType,
            token,
        };

        const requestMessage = new Message(
            getName(MessageEnum.RestAPIRequestMessage)
        );

        this.paymentActivitiesApiCallId = requestMessage.messageId;

        requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), webConfigJSON.paymentActivitiesEndPoint);
        requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), webConfigJSON.dashboarApiMethodType);
        requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), headers);

        runEngine.sendMessage(requestMessage.id, requestMessage)
    }
    // Customizable Area End
}
